/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Tab_KeywordInputs */

const en_landing_tab_keyword = /** @type {(inputs: Landing_Tab_KeywordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keywords`)
};

const de_landing_tab_keyword = /** @type {(inputs: Landing_Tab_KeywordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keywords`)
};

const fr_landing_tab_keyword = /** @type {(inputs: Landing_Tab_KeywordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keywords`)
};

const es_landing_tab_keyword = /** @type {(inputs: Landing_Tab_KeywordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keywords`)
};

const it_landing_tab_keyword = /** @type {(inputs: Landing_Tab_KeywordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keywords`)
};

const nl_landing_tab_keyword = /** @type {(inputs: Landing_Tab_KeywordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keywords`)
};

const pl_landing_tab_keyword = /** @type {(inputs: Landing_Tab_KeywordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keywords`)
};

const fi_landing_tab_keyword = /** @type {(inputs: Landing_Tab_KeywordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keywords`)
};

const da_landing_tab_keyword = /** @type {(inputs: Landing_Tab_KeywordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keywords`)
};

const sv_landing_tab_keyword = /** @type {(inputs: Landing_Tab_KeywordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keywords`)
};

/**
* | output |
* | --- |
* | "Keywords" |
*
* @param {Landing_Tab_KeywordInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_tab_keyword = /** @type {((inputs?: Landing_Tab_KeywordInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Tab_KeywordInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_tab_keyword(inputs)
	if (locale === "fr") return fr_landing_tab_keyword(inputs)
	if (locale === "es") return es_landing_tab_keyword(inputs)
	if (locale === "it") return it_landing_tab_keyword(inputs)
	if (locale === "nl") return nl_landing_tab_keyword(inputs)
	if (locale === "pl") return pl_landing_tab_keyword(inputs)
	if (locale === "fi") return fi_landing_tab_keyword(inputs)
	if (locale === "da") return da_landing_tab_keyword(inputs)
	if (locale === "sv") return sv_landing_tab_keyword(inputs)
	return en_landing_tab_keyword(inputs)
});